var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewWindow = function SvgNewWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 4 8.4 9.4c-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0L16 6.1v2.4c0 .8.7 1.5 1.5 1.5S19 9.3 19 8.5V1h-7.5c-.8 0-1.5.7-1.5 1.5S10.7 4 11.5 4h2.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.5C1 7.6 2.6 6 4.5 6H7c.8 0 1.5.7 1.5 1.5S7.8 9 7 9H4.5c-.3 0-.5.2-.5.5v6c0 .3.2.5.5.5h6c.3 0 .5-.2.5-.5v-2.4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v2.4c0 1.9-1.6 3.5-3.5 3.5h-6C2.6 19 1 17.4 1 15.5v-6z"
  })));
};
export default SvgNewWindow;